<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Admin One Approval</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <b-table v-if="loaded" striped hover :items="response" show-empty="true" empty-text='There are no records to show'
                                 :fields="['SubmittedDate','SubmitterName','Approvals','ReportName','Project','Type','Status','ReimbursementTotal']">
                            <template v-slot:cell(ReportName)="data">
                                <span v-html="data.value"></span>
                            </template>
                            <template v-slot:cell(SubmittedDate)="data">
                                {{data.value | formatDate}}
                            </template>
                            <template v-slot:cell(ReimbursementTotal)="data">
                                {{data.value | currency}}
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService'

    export default {
        async created() {
            this.response = await ReportService.getAdminOneApprovals();
            this.loaded = true;
        },
        data() {
            return {
                response: null,
                loaded: false
            }
        },
        methods: {
        }
    }
</script>